import qs from "qs";
import { useCallback, useEffect, useMemo, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { ContractApprovalStatus, ContractStep, DetailTotalData } from "src/api/contract/contract-types";
import { BaseButton, BaseModal, BaseTextarea, ContentsTitle } from "src/components";
import MetaTag from "src/components/layout/MetaTag";
import useNavigate from "src/hooks/usePartnerNavigate";
import ContractAccessGroup from "../commonComponents/accessGroupInfo/ContractAccessGroup";
import ContractReservation from "../commonComponents/reservation/ContractReservation";
import useContractStatusChange from "../hooks/useContractStatusChange";

import _ from "lodash";
import { useApiOperation } from "src/api/hooks";
import { getReservationListAsync } from "src/api/reservation/reservation-api";
import HistoryDetail from "src/components/histroy/HistoryDetail";
import { usePartnerAuthority } from "src/hooks/usePartnerAuthority";
import GuideTab from "src/pages/guide/components/GuideTab";
import { useModal } from "src/recoil/modalState/hook";
import { CONTRACT_APPROVAL_STATUS_OPTIONS } from "../contract-constants";
import useContractApi from "../hooks/useContractApi";
import useEsignApi from "../hooks/useEsignApi";
import useModuSign from "../hooks/useModuSign";
import ContractBasicInfo from "./components/basicInfo/BasicInfo";
import ContractDetailComponent from "./components/contractDetail/ContractDetailComponent";
import ContractIotDevice from "./components/iotDevice/ContractIotDevice";

interface ViewStringDatas {
  contractManageId: string;
  contractStep: string;
}

// import ContractReservation from "./components/reservation/ContractReservation";
let tabs = [
  { value: "basicInfo", label: "기본정보" },
  { value: "contract", label: "계약" },
  { value: "accessLevel", label: "출입 관리" },
  { value: "reservation", label: "공용공간" },
  { value: "guide", label: "이용안내" },
  { value: "iotDevice", label: "IoT 기기" },
  { value: "history", label: "변경내역" },
];

const IncompleteReason: any = [
  { code: "ALREADY_RESERVED", label: "이미 예약 선점" },
  { code: "DAILY_QUOTA_EXCEED", label: "일일 예약 시간 초과" },
  { code: "MONTHLY_QUOTA_EXCEED", label: "월 예약 시간 초과" },
  { code: "CALENDAR_RESOURCE_DECLINED", label: "캘린더 리소스 거부" },
  { code: "CALENDAR_EMPTY_RESOURCE", label: "캘린더 리소스 참석자 없음" },
  { code: "CALENDAR_MULTIPLE_RESOURCES", label: "캘린더 리소스가 중복 지정" },
  { code: "OUT_OF_BOUNDS", label: "예약 가능 구간을 벗어남" },
  { code: "OUT_OF_TIME", label: "예약 가능 시간 단위를 벗어남 " },
  { code: "BUSINESS_CLOSED", label: "휴무 시간에 예약" },
  { code: "UNKNOWN", label: "알 수 없음" },
];

const ContractDetailMain = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const statusBtnDisables: Array<string> = [ContractStep.APPLY_CANCEL, ContractStep.TERMINATE_COMPLETE, ContractStep.USE_COMPLETE];
  const { executeAsync: getReservationList } = useApiOperation(getReservationListAsync, { noLoading: true });

  const queryParams = useMemo(
    () =>
      qs.parse(location.search, {
        ignoreQueryPrefix: true,
        allowDots: true,
        decoder: (c) => c,
      }),
    [location],
  );
  const { id } = useParams();

  const { getContractDetail } = useContractApi();

  // 모두싸인 문서 목록 조회
  const { fetchModuSignDocumentList } = useModuSign();

  // 모두싸인 권한 조회
  const { getPartnerEsignCheck } = useEsignApi();

  const { statusBtnShow, changeStatus } = useContractStatusChange();

  let makeDetailDatas: DetailTotalData = {};
  const [detailData, setDetailData] = useState<DetailTotalData>(makeDetailDatas);
  const [viewData, setVieeData] = useState<ViewStringDatas>({ contractManageId: "", contractStep: "" });

  const [message, setMessage] = useState<any>({
    failStatus: false,
    successStatus: false,
    message: "",
    title: "",
    step: "",
  });
  // const [successStatus, setSuccessStatus] = useState(false);
  const [options, setOptions] = useState<any>([]);
  const [validations, setValidations] = useState<any>([]);
  const [isOperationCheck, setIsOperationCheck] = useState(false);
  const [rejectReason, setRejectReason] = useState("");

  const [isLoading, setIsLoading] = useState(false);
  const [noAuthModal, setNoAuthModal] = useState(false);

  // 승인/반려 모달 상태
  const [approvalModal, setApprovalModal] = useState<{
    isOpen: boolean;
    type: ContractApprovalStatus | null;
  }>({ isOpen: false, type: null });

  const { isAuthority } = usePartnerAuthority();
  const { setBaseModal } = useModal();

  // 현재 활성화 되어야하는 tab
  const activeTab = useMemo(() => {
    if (queryParams?.tab) {
      return tabs.find((tab) => tab.value === queryParams?.tab);
    }
    return tabs[0];
  }, [queryParams]);

  // BASIC r 권한 없이 이용안내 탭 직접 접근 시 모달 표시
  useEffect(() => {
    if (queryParams?.tab === "guide" && !isAuthority("r", "BASIC")) {
      setNoAuthModal(true);
    }
  }, [queryParams?.tab, isAuthority]);

  const renderNoAuthModal = (onClickHandler: Function) => {
    return (
      <>
        <div className="base-modal__title text-primary">
          <p>접근 권한이 없습니다.</p>
        </div>
        <div className="base-modal__contents pt20">
          <p>관리자에게 문의해 주세요</p>
        </div>
        <div className="base-modal__btn-wrap">
          <BaseButton title={"확인"} onClick={onClickHandler} />
        </div>
      </>
    );
  };

  // 탭 클릭시 callback 함수
  const clickTab = useCallback(
    async (tab: { value: string; label: string }) => {
      const newQueryParams = { ...queryParams };
      if (
        (tab.value === "accessLevel" || tab.value === "reservation") &&
        (makeDetailDatas?.contract?.contractStep === ContractStep.APPLY_RECEIVED ||
          makeDetailDatas?.contract?.contractStep === ContractStep.APPLY_CONFIRM)
      ) {
        setIsOperationCheck(true);
        setMessage("현재 계약 상태에서는 열람할 수 없습니다.");
        return;
      } else {
        if (newQueryParams?.tab) {
          delete newQueryParams.tab;
        }

        if (newQueryParams?.tabType) {
          delete newQueryParams?.tabType;
          delete newQueryParams?.tabId;
        }

        newQueryParams.tab = tab.value;
        // query parameter 에 tab 추가
        const newQueryParamStr = qs.stringify(newQueryParams, { allowDots: true });
        navigate(location.pathname + "?" + decodeURIComponent(newQueryParamStr));
      }
    },
    [queryParams, makeDetailDatas?.contract?.contractStep, navigate, location.pathname],
  );

  const breadCrumbs = [{ value: "contract", label: "신청/계약" }];
  if (activeTab) {
    // 마지막 bread crumb 는 현재 선택된 탭
    breadCrumbs.push({
      value: activeTab.value,
      label: activeTab.label,
    });
  }

  const checkTabs = useMemo(() => {
    let rtnTabs = _.cloneDeep(tabs);
    if (detailData && detailData.contract && detailData.product.productType === "NON_RESIDENT_OFFICE") {
      rtnTabs = [
        { value: "basicInfo", label: "기본정보" },
        { value: "contract", label: "계약" },
        { value: "accessLevel", label: "출입 관리" },
        { value: "iotDevice", label: "IoT 기기" },
      ];
    }
    if (!isAuthority("r", "BASIC")) {
      rtnTabs = rtnTabs.filter((tab) => tab.value !== "guide");
    }
    return rtnTabs;
  }, [detailData, isAuthority]);

  const setData = useCallback(async () => {
    if (id) {
      const contractDetail = await getContractDetail(String(id));

      const view: ViewStringDatas = {
        contractManageId: String(contractDetail?.contractManage?.contractManageId ?? ""),
        contractStep: String(contractDetail?.contract?.contractStep),
      };
      setVieeData(view);
      //상태값으 조회해야한다.

      // RCS02: 모두싸인 권한 조회
      let isModuSignAvailable = false;
      try {
        const hasModuSignPermission = await getPartnerEsignCheck();
        isModuSignAvailable = hasModuSignPermission?.isModuSignAvailable || false;
      } catch (error) {
        console.error("모두싸인 권한 조회 실패:", error);
      }

      // RCS55는 계약 상태 변경(계약체결) 시점에 호출
      const status = statusBtnShow(
        String(contractDetail?.contract?.contractStep),
        String(contractDetail?.contractManage?.spaceProductType),
        contractDetail,
        setMessage,
        isModuSignAvailable ? async () => (await fetchModuSignDocumentList())?.documents || [] : undefined,
      );
      setOptions(status.rtnOptionArr);
      setValidations(status.validator);

      setDetailData(contractDetail);
    }
  }, [id]);

  // 예약 상태 확인 함수 (15초 동안 반복)
  const checkReservationWithTimeout = useCallback(
    async (contractId: string): Promise<any> => {
      const startTime = Date.now();
      const timeoutLimit = 15000; // 15초

      const checkReservation = async (): Promise<any> => {
        const result = await getReservationList({
          contractId,
          containsOrganizerMemberNo: detailData.contractManage?.contractorList![0]!.memberNo,
        }).catch((error: unknown) => {
          console.error("Error fetching reservations:", error);
          return undefined;
        });

        const reservations = result?.data?.data?.content || [];

        // 예약 상태 확인
        const hasAcknowledged = reservations.some((reservation: any) => reservation.status.code === "ACKNOWLEDGED");
        const hasCancelled = reservations.some(
          (reservation: any) => reservation.status.code === "CANCELLED" || reservation.status.code === "INCOMPLETE",
        );
        //for TIMEOUT test
        // const hasAcknowledged = false;
        // const hasCancelled = false;

        if (hasAcknowledged) {
          return result;
        }

        if (hasCancelled) {
          const failedReservation = reservations.find(
            (reservation: any) => Array.isArray(reservation.incompleteReasons) && reservation.incompleteReasons.length > 0,
          );

          const errorCodes = failedReservation?.incompleteReasons?.map((reason: any) => reason.code).filter(Boolean) || [];

          if (errorCodes.length > 0) {
            throw new Error("CANCELLED", { cause: errorCodes.join(", ") });
          }
          throw new Error("CANCELLED");
        }

        // 종료 조건 미충족 → 시간 남았으면 1초 대기 후 재조회, 다 됐으면 TIMEOUT
        if (Date.now() - startTime < timeoutLimit) {
          await new Promise((resolve) => setTimeout(resolve, 1000));
          return checkReservation();
        }

        throw new Error("TIMEOUT");
      };

      setIsLoading(true);
      return checkReservation().finally(() => setIsLoading(false));
    },
    [getReservationList, detailData.contractManage?.contractorList],
  );

  // 기본 상태 변경 처리
  const handleBasicStatusChange = useCallback(
    async (status: string) => {
      await changeStatus(status, Number(id));
      setMessage({ failStatus: true, title: "저장되었습니다.", message: "" });
      await setData();
    },
    [changeStatus, id, setData],
  );

  // TIME_COURT 타입의 CONTRACT_ACCEPT 처리
  const handleTimeCourtAccept = useCallback(
    async (status: string) => {
      await changeStatus(status, Number(id));

      const handleReservationCheck = async () => {
        try {
          await checkReservationWithTimeout(String(id));
          setMessage({ failStatus: true, title: "저장되었습니다.", message: "" });
          await setData();
        } catch (error: any) {
          if (error?.message === "TIMEOUT") {
            setBaseModal({
              isOpen: true,
              title: "처리가 지연되고 있습니다.",
              children: (
                <div>
                  <p>계속 기다리시거나, 요청을 취소하고</p>
                  <p>다시 시도하실 수 있습니다.</p>
                </div>
              ),
              btnLeftTitle: "신청 취소",
              btnRightTitle: "재시도",
              onClick: async () => {
                setBaseModal({ isOpen: false });
                await handleReservationCheck(); // 재귀적으로 호출
              },
              onClose: async () => {
                setBaseModal({ isOpen: false });
                const rtn = await getContractDetail(String(id));
                if (rtn.contract?.contractStep !== "APPLY_CANCEL") {
                  await changeStatus("APPLY_CANCEL", Number(id));
                  setMessage({ failStatus: true, title: "계약 상태 변경", message: "신청 취소되었습니다." });
                }
                await setData();
              },
            });
            return;
          }

          if (error?.message === "CANCELLED") {
            const errorCodes = error?.cause?.split(", ");
            const errorLabels = errorCodes?.map((error: string) => IncompleteReason.find((reason: any) => reason.code === error) || error) || [];

            setBaseModal({
              isOpen: true,
              title: "예약에 실패하였습니다.",
              children: errorCodes ? (
                <div className="flex-d flex-row">
                  <p>아래와 같은 사유로 예약에 실패하였습니다.</p>
                  <p>다시 시도해주세요</p>
                  <div className="w-100 text-left py10 px15 mt20 overflow-scroll" style={{ backgroundColor: "#F2F4F6", maxHeight: 250 }}>
                    {errorLabels.map((error: any) => (
                      <div key={error.code}>
                        • <span>{error.label}</span>
                      </div>
                    ))}
                  </div>
                </div>
              ) : (
                "다시 시도해 주세요."
              ),
              btnRightTitle: "확인",
              onClick: async () => {
                setBaseModal({ isOpen: false });
                await setData();
              },
              onClose: async () => {
                setBaseModal({ isOpen: false });
                await setData();
              },
            });
            return;
          }

          setMessage({
            failStatus: true,
            title: "계약 상태 변경 실패",
            message: error?.message || "예약 확인 중 오류가 발생했습니다.",
          });
          await setData();
        }
      };

      await handleReservationCheck();
    },
    [changeStatus, id, checkReservationWithTimeout, setData, setBaseModal],
  );

  const statusChange = useCallback(
    async (status: string) => {
      if (detailData?.product?.productType === "TIME_COURT" && status === "CONTRACT_ACCEPT") {
        await handleTimeCourtAccept(status);
      } else {
        await handleBasicStatusChange(status);
      }
    },
    [detailData?.product?.productType, handleTimeCourtAccept, handleBasicStatusChange],
  );

  useEffect(() => {
    setData();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [setData]);

  // console.log("detailData :>> ", detailData);

  // 승인/반려 처리 실행 함수
  const executeApprovalChange = async () => {
    const type = approvalModal.type;
    if (!type) return;

    switch (type) {
      case "APPROVED":
        await changeStatus("CONTRACT_ACCEPT", Number(id));
        await setData();
        break;
      case "REJECTED":
        await changeStatus("APPLY_CANCEL", Number(id), rejectReason || "-");
        await setData();
        break;
    }
    setApprovalModal({ isOpen: false, type: null });
    setRejectReason("");
  };

  const onChangeApprovalStatus = (value: ContractApprovalStatus) => {
    if (value === "PENDING") {
      return;
    }

    if (value === "APPROVED") {
      // 승인은 기존 방식대로 setBaseModal 사용
      setBaseModal({
        isOpen: true,
        title: "계약을 승인하시겠습니까?",
        onClick: async () => {
          setBaseModal({ isOpen: false }); // 폴링 중 로딩 모달과 겹치지 않게 먼저 닫음
          // TIME_COURT 상품은 예약 폴링이 필요하므로 기존 핸들러로 위임 (changeStatus + checkReservationWithTimeout + TIMEOUT/CANCELLED 알럿 + setData)
          if (detailData?.product?.productType === "TIME_COURT") {
            await handleTimeCourtAccept("CONTRACT_ACCEPT");
          } else {
            await changeStatus("CONTRACT_ACCEPT", Number(id));
            await setData();
          }
        },
        onClose: () => {
          setBaseModal({ isOpen: false });
        },
        btnRightTitle: "확인",
        btnLeftTitle: "취소",
      });
    } else {
      // 반려는 별도 모달 state 사용
      setRejectReason("");
      setApprovalModal({ isOpen: true, type: value });
    }
  };

  return (
    <>
      <MetaTag subTitle={viewData.contractManageId} />
      <div>
        {noAuthModal && (
          <BaseModal isOpen={noAuthModal}>
            {renderNoAuthModal(() => {
              setNoAuthModal(false);
              const searchParams = new URLSearchParams(location.search);
              searchParams.set("tab", "basicInfo");
              navigate(`${location.pathname}?${searchParams.toString()}`);
            })}
          </BaseModal>
        )}
        {isLoading && (
          <BaseModal isOpen={isLoading} title={"예약 상태를 확인 중입니다"}>
            <p>잠시만 기다려 주세요.</p>
          </BaseModal>
        )}
        <ContentsTitle
          title="신청/계약"
          tabs={checkTabs}
          activeTab={activeTab}
          clickTab={clickTab}
          detailInfo={[
            { title: "계약 ID", value: String(id) || "" },
            { title: "계약관리 ID", value: viewData.contractManageId },
          ]}
          selectValue={viewData.contractStep}
          selectOptions={options}
          setSelectStateValue={async (value: any) => {
            const finded = validations.find((obj: any) => obj.key === value);

            if (finded && finded.validation) {
              console.log("finded :>> ", finded);
              await finded.messages();
            }
          }}
          selectDisabled={
            statusBtnDisables.includes(String(detailData?.contract?.contractStep)) || //
            (detailData?.contract?.approvalStatus === "PENDING" && detailData?.contract?.approvalType === "ADMIN")
          }
          colorType={"contract"}
          // 승인대기 select > 관리자승인 일경우 select 노출
          {...(detailData?.contract?.approvalType === "ADMIN" && {
            selectValue2: detailData?.contract?.approvalStatus,
            selectOptions2: CONTRACT_APPROVAL_STATUS_OPTIONS.filter((option) => option.label !== "전체"),
            setSelectStateValue2: (value: ContractApprovalStatus) => {
              onChangeApprovalStatus(value);
            },
            colorType2: "contract2",
            selectDisabled2: detailData?.contract?.approvalStatus !== "PENDING",
          })}
        />
        {/* !isAuthority("CONTRACT", "w") */}
        {/* 기본정보 */}
        {activeTab?.value === "basicInfo" && <ContractBasicInfo detailData={detailData!} setData={setData} />}
        {/* 계약 */}
        {activeTab?.value === "contract" && <ContractDetailComponent detailData={detailData!} setData={setData} />}
        {/* 출입관리 */}
        {activeTab?.value === "accessLevel" && <ContractAccessGroup detailData={detailData!} />}
        {/* 공용공간 */}
        {activeTab?.value === "reservation" && <ContractReservation detailData={detailData!} />}
        {/* 이용안내 */}
        {activeTab?.value === "guide" && (
          <GuideTab serviceId={String(detailData?.contract?.contractManageId)} serviceType={"SERVICE_CONTRACT_MANAGE"} detailData={detailData!} />
        )}
        {/*IoT 기기  */}
        {activeTab?.value === "iotDevice" && <ContractIotDevice detail={detailData!} />}
        {/* 변경내역 */}
        {activeTab?.value === "history" && detailData?.contract?.contractId && detailData.contract?.contractManageId && (
          <HistoryDetail
            identifier={{
              contractId: String(detailData.contract?.contractId),
              contractManageId: String(detailData.contract?.contractManageId),
            }}
          />
        )}
        {isOperationCheck && (
          <BaseModal isOpen={isOperationCheck} btnRightTitle="확인" onClick={() => setIsOperationCheck(false)} title={message.message}></BaseModal>
        )}
        {message.failStatus && (
          <BaseModal
            isOpen={message.failStatus}
            btnRightTitle="확인"
            onClick={() => setMessage({ ...message, ...{ failStatus: false, message: "", title: "", step: "" } })}
            title={message.title}
            className="pre-formatted text-left"
          >
            {message.message && <p>{message.message}</p>}
          </BaseModal>
        )}
        {message.successStatus && (
          <BaseModal
            isOpen={message.successStatus}
            btnLeftTitle="취소"
            btnRightTitle="확인"
            onClose={() => setMessage({ ...message, ...{ successStatus: false, message: "", title: "", step: "" } })}
            onClick={() => {
              // console.log("clicked!!!");
              setMessage({ ...message, ...{ successStatus: false, message: "", title: "", step: "" } });
              statusChange(message.step);
            }}
            title={message.title}
          >
            {message.message && <p>{message.message}</p>}
          </BaseModal>
        )}
        {/* 반려 모달*/}
        {approvalModal.isOpen && approvalModal.type === "REJECTED" && (
          <BaseModal
            isOpen={approvalModal.isOpen}
            title="계약을 반려하시겠습니까?"
            btnLeftTitle="취소"
            btnRightTitle="확인"
            onClose={() => {
              setApprovalModal({ isOpen: false, type: null });
              setRejectReason("");
            }}
            onClick={executeApprovalChange}
          >
            <p className="mb20 text-primary3">
              반려 시 계약은 자동으로 취소되며, 신청자에게
              <br /> 취소 안내가 발송됩니다. 처리 완료 후에는
              <br /> 되돌릴 수 없으니, 신중히 진행해 주시기 바랍니다.
            </p>
            <BaseTextarea
              placeholder="반려사유 (입력한 내용은 반려 처리 시 계약 신청자에게 전송됩니다.)"
              onChange={(change: string) => setRejectReason(change)}
              value={rejectReason}
              name="rejectReason"
              maxLength={200}
            />
          </BaseModal>
        )}
      </div>
    </>
  );
};

export default ContractDetailMain;
